import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GameButtonComponent } from '@new-core/components/buttons-game/game-button/game-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { ResultFormBgModule } from '../result-form-bg/result-form-bg.module';
import { AnswerResultFormComponent } from './answer-result-form.component';
import {MatTooltip} from "@angular/material/tooltip";

@NgModule({
  declarations: [AnswerResultFormComponent],
  exports: [AnswerResultFormComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ResultFormBgModule,
    GameButtonComponent,
    CalculatorModule,
    MatTooltip,
  ],
})
export class AnswerResultFormModule {}
